import React, { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import "./epicbutton.scss";
import addEpicIcone from "../../../../../styles/svg/add-epic.svg";
import addIcon from "../../../../../styles/svg/group-plus-icon.svg";
import AddMilestone from "../../../../../components/Milestone/addMilestone";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { TooltipName } from "../../../../../utils/Enums";
import { CustomButton } from "../../../../../components/Button/Button";

const CreateEpic = ({ isTab = false }) => {
  const [addMilestonePop, setAddMileStonePop] = useState(false);
  const isMobile = useResponsive("down", "md");

  return (
    <>
      {isTab ? (
        <Tooltip title={TooltipName.BOARD_PAGE.CREATE_NEW_MILESTONE}>
        <CustomButton
          size="small"
          className="create-card-btn reset-btn"
          onClick={() => setAddMileStonePop(true)}
        >
          <AddIcon className="add-icon" />
        </CustomButton>
        </Tooltip>
      ) : (
        <div
          className="create-epic-btn"
          onClick={() => setAddMileStonePop(true)}
        >
          {isMobile ? (
            <img src={addIcon} alt="create milestone" />
          ) : (
            <CustomButton
              className="create-epic-button"
              variant="contained"
            >
              <img src={addEpicIcone} alt="add milestone" /> Create New
            </CustomButton>
          )}
        </div>
      )}

      <AddMilestone
        open={addMilestonePop}
        handleClose={() => setAddMileStonePop(false)}
        title={"Create Milestone"}
        btnTitle={"Create"}
      />
    </>
  );
};

export default CreateEpic;
